import { LoginClient } from 'NSwag/ServerClient/Client.nswag';

class Client extends LoginClient {

    static instance: Client;

    constructor(url: string) {
        if (!Client.instance) {
            super(url);
            Client.instance = this;
        }

        return Client.instance;
    }
}

const client = new Client(`${window.apiPath}`);

Object.freeze(client);

export default client;